import React from "react";

const ProductContent = () => {
    return ( <div></div> );
}
 
export default ProductContent;